import { useEffect } from 'react';
import { makePayload } from '../utils/customerDisplay';
import { sendCustomerDisplay, isCustomerDisplayAvailable } from '../utils/customerDisplayBridge';

/**
 * Customer (second) screen while a payment screen is open: 'payment' with the items and the full
 * totals, re-sent (debounced, de-duplicated by the bridge) whenever either changes, and 'idle' as
 * soon as the screen is left or the order has been paid (`enabled` false). Pages that take over
 * afterwards (the cart page, the dashboard reset) send their own state. A no-op without a wrapper
 * that has updateCustomerDisplay.
 */
export default function useCustomerDisplayPayment({ items, totals, enabled = true }) {
  useEffect(() => {
    if (!enabled || !items || !totals || !isCustomerDisplayAvailable()) return undefined;
    const timeout = setTimeout(() => {
      sendCustomerDisplay(makePayload('payment', { items, totals }));
    }, 150);
    return () => clearTimeout(timeout);
  }, [items, totals, enabled]);

  // Paid: the customer is done, go back to the idle logo straight away.
  useEffect(() => {
    if (!enabled) sendCustomerDisplay(makePayload('idle'));
  }, [enabled]);

  // Left the payment screen.
  useEffect(() => () => {
    sendCustomerDisplay(makePayload('idle'));
  }, []);
}
